import { Layout } from 'antd'
import { Header } from '../components/Header'
import { HeaderPublic } from '../components/HeaderPublic'
import { SideMenu } from '../components/SideMenu'
import { SideMenuPublic } from '../components/SideMenuPublic'
import { TemplateProps } from './Template.props'
import * as S from './style'

export function Template ({ children, pageTitle, hasBreadCrumb, isPublicPage, isSetup }: TemplateProps): React.ReactElement {
  const isSuperAdmin = window.localStorage.getItem('is_super_admin') === 'true'

  if (isSetup) return <Layout style={{ minHeight: '100dvh', background: '#f4f6f9' }}>{children}</Layout>

  return <Layout>
    {!isPublicPage && <SideMenu />}
    {isPublicPage && <SideMenuPublic />}
    <Layout style={{
      backgroundColor: '#f6f8fa',
      maxHeight: '100vh',
      overflowY: 'auto'
    }}>
      {!isPublicPage && <Header title={pageTitle} />}
      {isPublicPage && <HeaderPublic />}
      {isSuperAdmin && (
        <div style={{
          background: '#ff4d4f',
          color: 'white',
          padding: '8px 16px',
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: '14px'
        }}>
          🔴 MODO SUPER ADMIN ATIVO
        </div>
      )}
      <S.Content>
        {children}
      </S.Content>
    </Layout>
  </Layout>
}
